export default __webpack_public_path__ + "static/img-main-1-c5029d0a77c6bfcb181e7919d9c07bd6.jpg";